function getQuery(){
    let search = new URLSearchParams(window.location.search);
    let params = Array.from(search.entries()).reduce((acc, curr) => {
        let [key, value] = curr;
        if(value == "true" || value == "false"){
            value = value == "true";
        } else if(/^\d+$/.test(value)){
            value = parseInt(value);
        } else if(/null|undefined/.test(value)){
            value = null;
        } else if(value == ""){
            value = undefined;
        }
        return {[key]: value, ...acc};
    }, {});

    return params;
}

export { getQuery };